<template>
  <ComponentGeneral :title="title" @componentLedgerBack="(page)=> $emit('changeTab',page)" @result="resultList">
    <div class="grid grid-cols-2 mt-5">
      <div class="font-bold">Grand Totals</div>
      <div class="flex flex-col gap-5">
        <div v-for="item in itemsTotal" class="grid grid-cols-2">
          <div class="font-bold">{{ item.title + ':' }}</div>
          <div class="place-self-center font-medium">{{ currencySymbol + sumCol(colsTotalTables,item.field,'general') }}</div>
        </div>
      </div>
    </div>
  </ComponentGeneral>
</template>
<script>
  import ComponentGeneral from "@/views/reports/bill/ComponentGeneral";
  import mixin from '../../mixin/mixin'

  export default {
    name:'Billing History',
    mixins:[mixin],
    components: {
      ComponentGeneral
    },
    data() {
      return {
        colsTotalTables: [],
        title: 'Billing History',
        itemsTotal: [
          { title: 'Amounts', field: 'total_amount' },
          { title: 'Payments',field: 'payed_amount' },
          { title: 'Balance', field: 'balance' },
        ]
      }
    },
    computed: {
      currencySymbol() {
        return localStorage.getItem('currency_symbol')
      },
    },
    methods: {
      resultList(list) {
        const convertArr = []
        const listArr = list.map(item => item.matters.map(bill => bill.bills))
        for (let a of listArr) {
          for (let b of a)
            for (let c of b) convertArr.push(c)
        }
        this.colsTotalTables = convertArr
      }
    }
  }
</script>
